import { flowType } from '@utility/userInfo';
import store from '@store';
import { LABEL } from '@veriables';
export const getSelections = ({ minimum, maximum }) => {
  let selector = '';
  if (minimum === maximum) {
    if (minimum > 1) {
      selector = `Pick ${maximum}`;
    } else if (minimum === 1) {
      selector = `Pick ${maximum}`;
    } else {
      selector = 'Pick any (optional)';
    }
  } else if (minimum !== maximum) {
    if (minimum === 0) {
      selector = `${LABEL().PICK_UP_TO} ${maximum} (${LABEL().OPTIONAL})`;
    } else {
      selector = `Pick ${minimum} to ${maximum} items`;
    }
  }

  return selector;
};
export const getPath = (data, dataToAppend) => {
  const arrayData = [...data];
  if (dataToAppend) {
    arrayData.push(dataToAppend);
  }
  return arrayData.join('|');
};

export const onModifierSelect = ({
  data,
  item,
  selectedModArray,
  modifierGroup,
  count,
  nestedModifierArray,
}) => {
  const { orders } = store.getState();
  const { modifierData, modifiersHashTable, collapsedModifierArray } = orders;
  const operator = data?.weight && data?.weight > 0 ? data?.weight : 1;

  const fullPath = getPath(nestedModifierArray, `${data?.modifierId}-${modifierGroup?.id}`);
  const isActive = modifierData?.some(
    m => m === fullPath || m.startsWith(`${fullPath}|`)
  );
  const countTemp = !isActive ? count - operator : count + operator;
  const modMax = modifierGroup?.maximum;
  let modArray = modMax === 1 ? [] : [...selectedModArray];

  const isTableTop = flowType() === 'tableTop';
  const isKiosk = flowType() === 'kiosk';
  if (isActive) {
    const itemModIndex = modArray.indexOf(data?.name || item?.name);
    if (itemModIndex === -1) {
      modArray.push(data?.name || item?.name);
      if (!isKiosk && !isTableTop) {
        if (modifierData.length > 0) {
          for (const modifier of modifierData) {
            if (modifier?.includes('|')) {
              const [firstPart, secondPart] = modifier.split('|');
              const id = firstPart.split('-')[0];
              const nameVal = modifiersHashTable[id]?.name;
              if (nameVal === modArray[0]) {
                const pushId = secondPart.split('-')[0];
                modArray.push(modifiersHashTable[pushId]?.name);
              }
            }
          }
        }
      }
    }
  } else {
    const itemIndex = selectedModArray.indexOf(data.name || item.name);
    modArray = modArray
      .slice(0, itemIndex)
      .concat(modArray.slice(itemIndex + 1, modArray.length));
  }
  let collapse = false;
  if (collapsedModifierArray.length > 0) {
    if (
      collapsedModifierArray.indexOf(modifierGroup.id) > -1 ||
      (countTemp >= modMax && modMax !== 0)
    ) {
      collapse = true;
    } else {
      collapse = false;
    }
  } else if (countTemp >= modMax && modMax !== 0) {
    collapse = true;
  }
  // console.log({ modArray, selectedModArray });

  return { modArray, countTemp, collapse };
};

export const handleModSelect = (
  modifierGroup,
  modifiersHashTable,
  modifierGroupsHashTable,
  nestedModifierArray,
  modifierData,
  selectedModArray,
  count
) => {
  const { orders } = store.getState();
  const { collapsedModifierArray } = orders;

  let modArray = [];
  let countTemp = 0;

  for (const data of modifierGroup.modifierLinks) {
    const operator = data?.weight && data?.weight > 0 ? data?.weight : 1;

    const firstPath = getPath(
      nestedModifierArray,
      `${data.modifierId}-${modifierGroup.id}`
    );

    const item = modifiersHashTable[data.modifierId];

    // check nested modifiers
    const matchingPaths = (modifierData || []).filter(
      d => d === firstPath || d.startsWith(`${firstPath}|`)
    );
    const plainCount = matchingPaths.filter(p => p === firstPath).length;
    const isNested = matchingPaths.some(p => p.startsWith(`${firstPath}|`));
    const qty = plainCount > 0 ? plainCount : (isNested ? 1 : 0);
    let isActive = qty > 0;

    // check nested modifiers
    if (item && item.modifierGroupLinks?.length > 0) {
      // Keep legacy explicit check for robustness, though prefix check above should cover it
      for (const modGroup of item.modifierGroupLinks) {
        for (const mod of modifierGroupsHashTable[modGroup.modifierGroupId]
          ?.modifierLinks || []) {

          const finalPath = `${firstPath}|${mod.modifierId}-${modGroup.modifierGroupId}`;

          if (
            modifierData.some(m => m === finalPath || m.startsWith(`${finalPath}|`))
          ) {
            isActive = true;
          }
        }
      }
    }

    if (isActive) {
      const name = item?.name;
      modArray.push(name);
      countTemp += operator * (qty > 0 ? qty : 1);
    }
  }

  const modMax = modifierGroup?.maximum;

  let collapse = countTemp >= modMax && modMax !== 0;
  if (collapsedModifierArray.length > 0) {
    collapse = collapse || collapsedModifierArray.includes(modifierGroup.id);
  }

  return { modArray, countTemp, collapse };
};
